import { render, staticRenderFns } from "./ManageOkrList.vue?vue&type=template&id=548e2f65&scoped=true"
import script from "./ManageOkrList.vue?vue&type=script&lang=js"
export * from "./ManageOkrList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548e2f65",
  null
  
)

export default component.exports